"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosClientError = isAxiosClientError;
exports.createAxiosClient = createAxiosClient;
const axios_1 = __importStar(require("axios"));
const httpError_1 = require("./httpError");
function isNodeReadableStream(data) {
    return (typeof data === 'object' &&
        data !== null &&
        typeof data.pipe === 'function' &&
        typeof data.toArray === 'function');
}
const CORRELATION_ID = 'X-Correlation-Id';
const CALLER_ID = 'X-Caller-Id';
const TEST_STRATEGY = 'X-Test-Strategy';
const LOCALE = 'Idf-Locale';
function isAxiosClientError(error) {
    if (!error) {
        return false;
    }
    return error?.isAxiosError === true;
}
function createAxiosClient(apiHost, options) {
    const client = axios_1.default.create({
        baseURL: `${apiHost}`,
        timeout: options.timeout,
        headers: {
            Accept: options.accept ?? 'application/json',
        },
    });
    async function accessTokenInterceptor() {
        if (options.accessTokenSource !== undefined) {
            const accessToken = await options.accessTokenSource();
            if (accessToken !== null) {
                return new axios_1.AxiosHeaders({ Authorization: `Bearer ${accessToken}` });
            }
        }
        return new axios_1.AxiosHeaders();
    }
    async function correlationIdInterceptor() {
        if (options.correlationIdSource !== undefined) {
            const correlationId = await options.correlationIdSource();
            if (correlationId !== null) {
                return new axios_1.AxiosHeaders({ [CORRELATION_ID]: correlationId });
            }
        }
        return new axios_1.AxiosHeaders();
    }
    function callerIdInterceptor() {
        const { callerId } = options;
        if (callerId) {
            return new axios_1.AxiosHeaders({ [CALLER_ID]: callerId });
        }
        return new axios_1.AxiosHeaders();
    }
    function localeSourceInterceptor() {
        const { localeSource } = options;
        if (localeSource) {
            return new axios_1.AxiosHeaders({ [LOCALE]: localeSource() });
        }
        return new axios_1.AxiosHeaders();
    }
    async function testStrategyInterceptor() {
        const { testStrategySource } = options;
        if (testStrategySource) {
            const testStrategy = await testStrategySource();
            if (testStrategy) {
                return new axios_1.AxiosHeaders({ [TEST_STRATEGY]: testStrategy });
            }
        }
        return new axios_1.AxiosHeaders();
    }
    function customHeadersInterceptor() {
        const { customHeaders } = options;
        if (customHeaders) {
            return new axios_1.AxiosHeaders(customHeaders);
        }
        return new axios_1.AxiosHeaders();
    }
    client.interceptors.request.use(async (config) => {
        const tokenHeader = await accessTokenInterceptor();
        const correlationIdHeader = await correlationIdInterceptor();
        const callerIdHeader = callerIdInterceptor();
        const localeHeader = localeSourceInterceptor();
        const testStrategyHeader = await testStrategyInterceptor();
        const customHeaders = customHeadersInterceptor();
        const headers = config.headers.concat(tokenHeader, correlationIdHeader, callerIdHeader, localeHeader, testStrategyHeader, customHeaders);
        return {
            ...config,
            headers,
        };
    });
    const MAINTENANCE_STATUS_CODE = 580;
    if (typeof window !== 'undefined') {
        client.interceptors.response.use(undefined, (error) => {
            if (isAxiosClientError(error) && error.response?.status === MAINTENANCE_STATUS_CODE) {
                window.location.href = '/maintenance';
                return new Promise(() => { });
            }
            return Promise.reject(error);
        });
    }
    client.interceptors.response.use(undefined, (error) => {
        if (isAxiosClientError(error) && options.useHttpError) {
            const responseData = error.response?.data;
            const unStreamedData = isNodeReadableStream(responseData)
                ? responseData.toArray()
                : Promise.resolve(responseData);
            return unStreamedData.then((data) => {
                throw new httpError_1.HttpError(error, data);
            });
        }
        return Promise.reject(error);
    });
    return client;
}
